export default {
  getPersonList(state) {
    return state.personList
  }
}
